import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'pid', headerName: 'Pid', width: 130 },
  { field: 'fullName', headerName: 'Name', width: 200 },
  { field: 'blocked', headerName: 'Blocked', width: 140 },
  { field: 'payments', headerName: 'Payments', width: 140 },
  { field: 'lastPayment', headerName: 'Last Payment', ...formatColWithDate, width: 165 },
  { field: 'register', headerName: 'Register', ...formatColWithDate, width: 141 },
  { field: 'firstPayment', headerName: 'First Payment', ...formatColWithDate, width: 165 },
  { field: 'timeout', headerName: 'Timeout', ...formatColWithDate, width: 141 },
  { field: 'country', headerName: 'Country', width: 130 },
];

interface CollusionsInfos {
  pid: number;
  firstName: string;
  lastName: string;
  blocked: true;
  payments: 0;
  lastPayment: string;
  register: string;
  firstPayment: string;
  timeout: string;
  country: string;
}

let index = 0;
function createData(collusions: CollusionsInfos) {
  index += 1;
  return { id: index, fullName: `${collusions.firstName} ${collusions.lastName}`, ...collusions };
}

const Collusions = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<CollusionsInfos[]>(`/admin/collusions/player/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<CollusionsInfos[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default Collusions;
